(function ($, undefined) {
    'use strict';
    var sitekey = 'YOUR_SITE_KEY';
    var ev;

    /* RECAPTCHA UTIL FUNCTION */
    /**
     * Render recaptchas dynamically.
     * @param	 btn				 An element referencing the button or a string
     *											referencing the Id of the element.
     * @param	 callback		A function to be called after recaptcha has
     *											completed its check. The function is passed back
     *											the recaptcha response and the form element.
     * @param	 validate		(optional) A boolean to know if a form needs to be
     *											validated using the formValidator in com/form.js.
     * @param	 form				(optional) A jQuery object reference the form to be
     *											validated using formValidator in com/form.js.
     */

    var recaptcha = function (btn, callback, validate, form) {
        if (btn && window.grecaptcha) {
            if (window.grecaptcha.render) {
                grecaptcha.render(btn, {
                    sitekey: sitekey,
                    callback: function (response) {
                        var formValidator = Fw.component.models().form.validateForm;
                        var validated = true;
                        if (validate) {
                            validated = false;
                            formValidator(form);
                            if (!form.hasClass('has-error')) {
                                validated = true;
                            }
                        }

                        if (validated) {
                            callback(response, form);
                        } else {
                            grecaptcha.reset();
                        }
                    },
                    badge: 'inline'
                });
            } else {
                setTimeout(function () {
                    recaptcha(btn, callback, validate, form);
                }, 250);
            }
        } else if (btn && !window.grecaptcha) {
            setTimeout(function () {
                recaptcha(btn, callback, validate, form);
            }, 250);
        }
    };

    var isSM = function () {
        return $('.is-sm-div').css('visibility') === 'visible';
    };
    var isXS = function () {
        return $('.is-xs-div').css('visibility') === 'visible';
    };
    var isIP = function () {
        return $('.is-ip-div').css('visibility') === 'visible';
    };
    var getViewportState = function () {
        if (isIP()) {
            return "ip";
        } else if (isXS()) {
            return "xs";
        } else if (isSM()) {
            return "sm";
        } else {
            return "desktop";
        }
    };


    var addOrReplaceParam = function (param, value, modifyHistory = true, addToHistory = false, data = {}) {
        var currentHref = location.href;
        var params = currentHref.indexOf('?') !== -1 ? currentHref.split('?')[1] : "";
        var paramsArray = params.indexOf('&') !== -1 ? params.split('&') : params.length > 0 ? [params] : [];

        var found = false;
        var newParams = "";
        if (paramsArray.length > 0) {
            newParams = paramsArray.map(function (p) {
                var key = p.indexOf('=') !== -1 ? p.split('=')[0] : p;
                if (key == param) {
                    found = true;
                    return (key + "=" + value);
                }
                return p;
            }).join('&');
            newParams = '?' + newParams;
        }

        if (!found) {
            var sep = paramsArray.length > 0 ? '&' : '?';
            newParams += sep + param + "=" + value;
        }
        if (modifyHistory) {
            if (addToHistory) {
                history.pushState(data, document.title, currentHref.split('?')[0] + newParams);
            } else {
                history.replaceState(data, document.title, currentHref.split('?')[0] + newParams);
            }
        } else {
            return currentHref.split('?')[0] + newParams;
    }
    };

    var getParamsMap = function () {
        var href = location.href;
        var params = location.href.split('?')[1];
        var map = {};

        if (params) {
            params.split('&').forEach((param) => {
                if (param.length != 0) {
                    const [key, value] = param.split("=");
                    map[key] = value;
                }
            });
        }

        return map;
    };

    var fetchPortionOfSite = function (url, selector, callback) {
        let resolveRef;
        let promise = new Promise(resolve => resolveRef = resolve);

        $.ajax({url}).done((html) => {
            let data = $(html);
            let dom = data.find(selector);

            if (callback instanceof Function) {
                callback(dom);
            }

            resolveRef(dom);
        });

        return promise;
    };

    var clamp = function (number, min, max, defaultIfNaN = 5) {
        let num = Math.min(Math.max(parseInt(number), min), max);
        return isNaN(num) ? defaultIfNaN : num;
    };

    var debounce = function (func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate)
                    func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow)
                func.apply(context, args);
        };
    };

    var removeLowercaseDiacritics = function (str) {
        var defaultDiacriticsRemovalMap = [
            {'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g},
            {'base': 'aa', 'letters': /[\uA733]/g},
            {'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g},
            {'base': 'ao', 'letters': /[\uA735]/g},
            {'base': 'au', 'letters': /[\uA737]/g},
            {'base': 'av', 'letters': /[\uA739\uA73B]/g},
            {'base': 'ay', 'letters': /[\uA73D]/g},
            {'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g},
            {'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g},
            {'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g},
            {'base': 'dz', 'letters': /[\u01F3\u01C6]/g},
            {'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g},
            {'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g},
            {'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g},
            {'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g},
            {'base': 'hv', 'letters': /[\u0195]/g},
            {'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g},
            {'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g},
            {'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g},
            {'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g},
            {'base': 'lj', 'letters': /[\u01C9]/g},
            {'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g},
            {'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g},
            {'base': 'nj', 'letters': /[\u01CC]/g},
            {'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g},
            {'base': 'oi', 'letters': /[\u01A3]/g},
            {'base': 'ou', 'letters': /[\u0223]/g},
            {'base': 'oo', 'letters': /[\uA74F]/g},
            {'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g},
            {'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g},
            {'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g},
            {'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g},
            {'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g},
            {'base': 'tz', 'letters': /[\uA729]/g},
            {'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g},
            {'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g},
            {'base': 'vy', 'letters': /[\uA761]/g},
            {'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g},
            {'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g},
            {'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g},
            {'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g}
        ];

        for (var i = 0; i < defaultDiacriticsRemovalMap.length; i++) {
            str = str.toLowerCase().replace(defaultDiacriticsRemovalMap[i].letters, defaultDiacriticsRemovalMap[i].base);
        }

        return str;
    };

    // from Tokan
    var formatNumberToMoney = function (number) {
        if (typeof number == "string") {
            number = parseFloat(number.replace(',', '.'));
        }
        if (isNaN(number)) {
            return null;
        }
        var lang = $("html").attr('lang');
        var moneyString = "";
        if (lang !== 'fr') {
            moneyString += '$';
        }
        moneyString += number.toFixed(2);
        if (lang == 'fr') {
            moneyString = moneyString.replace(".", ",");
            moneyString += '$';
        }
        return moneyString;
    };

    var scrollToElement = function (element, duration = 300, offset = 0) {
        $("html, body").animate({
            scrollTop: element.offset().top - offset
        }, duration);
    };

    var isJson = function (str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    };

    var priceTextToFloat = function (priceText) {
        return parseFloat(priceText.replace('$', ''));
    };

    var appendDataToSubmit = function (form, data) {
        form.find('.js-form-submit-input').each(function () {
            if (this.type === 'checkbox') {
                var val = (this.checked) ? 'true' : 'false';
                if (this.getAttribute('data-value') !== val) {
                    data[this.name] = val;
                }
            } else if (this.type === 'radio') {
                if ($(this).prop('checked')) {
                    data[this.name] = this.value;
                }
            } else if (this.type === 'hidden') {
                data[this.name] = this.value;
            } else {
                if ($(this).closest('.form-select-ctn').hasClass('select-state-input-ctn')) {
                    if ($(this).closest('.form-select-ctn').hasClass('selected') && (this.name !== 'password' || this.getAttribute('data-value') !== this.value)) {
                        data[this.name] = this.value;
                    }
                } else {
                    if (this.name !== 'password' || this.getAttribute('data-value') !== this.value) {
                        data[this.name] = this.value;
                    }
                }
            }
        });
        return data;
    };

    var closePopup = function () {
        var btn = $(this);
        btn.closest('.stool-shared-popup').removeClass('visible');
    };

    var resumeEvent = function () {
        $(this).closest('.stool-shared-popup-inner').addClass('has-processing_active');
        window.location.href = ev.attr('href');
    };

    var getRequestParams = function () {
        var searchParamsArray = location.search.replace("?", "").split("&");
        var requestParams = {};
        searchParamsArray.map(item => {
            if (item) {
                var itemSplit = item.split("=");
                requestParams[itemSplit[0]] = itemSplit[1];
            }
        });
        return requestParams;
    };

    var requestParamsObjectToString = function (requestParams) {
        var params = "";
        for (var key in requestParams) {
            if (requestParams.hasOwnProperty(key)) {
                if (params.length > 0) {
                    params += "&";
                }
                params += key + "=" + requestParams[key];
            }
        }
        if (params.length > 0) {
            params = '?' + params;
        }
        return params;
    };
    
    var setRequestParams = function (map = {}) {
        window.location.search = requestParamsObjectToString(
            Object.assign(getRequestParams(), map));
    };

    var sendEmail = function (email, subject, message, file, fields, callback, count = 6) {
        var params = {
            email: email,
            subject: subject,
            file: file
        };
        if (message) {
            params.message = message;
        }
        for (var key in fields) {
            if (fields.hasOwnProperty(key) && parseInt(key.split("field")[1]) <= count) {
                params[key] = fields[key];
            }
        }
        if (fields.count) { // needed if there is more than 6 custom fields
            params.count = fields.count;
        }
        $.ajax({
            url: "/action/sendEmail",
            method: "post",
            data: params,
            cache: false,
            complete: function (response) {
                if (typeof callback === "function")
                    callback(response.responseText);
            }
        });
    };

    // https://medium.com/@mhagemann/the-ultimate-way-to-slugify-a-url-string-in-javascript-b8e4a0d849e1
    var slugify = function (string, isForComponent = false) {
        let a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìıİłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/,:;';
        if (!isForComponent)
            a += '_';
        let b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz-----';
        if (!isForComponent)
            b += '-';
        let p = new RegExp(a.split('').join('|'), 'g');
        var baseString = string.toString();
        if (!isForComponent)
            baseString = baseString.toLowerCase();

        return baseString
                .replace(/\s+/g, '-') // Replace spaces with -
                .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
                .replace(/&/g, '-and-') // Replace & with 'and'
                .replace(/[^\w\-]+/g, '') // Remove all non-word characters
                .replace(/\-\-+/g, '-') // Replace multiple - with single -
                .replace(/^-+/, '') // Trim - from start of text
                .replace(/-+$/, '') // Trim - from end of text
            ;
    };
    
    var toggleElement = function () {
        var t = $(this);
        var ctn = t.closest('.toggle-outer-ctn');
        var el = ctn.find('.element-to-toggle');

        if (!el.length) {
            if (t.attr('data-id')) {
                el = $('.element-to-toggle[data-id=' + t.attr('data-id') + ']');
            } else {
                return;
            }
        }

        if (t.hasClass('close-all')) {
            $('.element-to-toggle').each(function () {
                if ($(this).attr('data-id') !== t.attr('data-id')) {
                    $(this).slideUp();
                }
            });
        }

        // el.each(function() {
        // 	if ($(this).css('display') !== 'none' && $(this).find('input, select').hasClass('required')) {
        // 		$(this).find('input.required, select.required').removeClass('required').addClass('derequired');
        // 	} else if ($(this).css('display') === 'none' && $(this).find('input, select').hasClass('derequired')) {
        // 		$(this).find('input.derequired, select.derequired').removeClass('derequired').addClass('required');
        // 	}

        // 	if ($(this).css('display') !== 'none' && $(this).find('input, select').hasClass('form-submit-input')) {
        // 		$(this).find('input.form-submit-input, select.form-submit-input').removeClass('form-submit-input').addClass('no-submit-input');
        // 	} else if ($(this).css('display') === 'none' && $(this).find('input, select').hasClass('no-submit-input')) {
        // 		$(this).find('input.no-submit-input, select.no-submit-input').removeClass('no-submit-input').addClass('form-submit-input');
        // 	}
        // });

        ctn.toggleClass('open');
        el.slideToggle(function () {
            if ($(this).css('display') === 'none' && $(this).hasClass('empty-inputs-on-close')) {
                $(this).find('input, select').val('');
            }
        });
    };

    var saveMG2SessionVariable = function (key, value, callback = () => {}) {
        var params = {
            key: key
        };
        if (value != null) {
            params.value = value;
        }
        $.ajax({
            url: "/action/sessionVariables",
            method: "post",
            data: params,
            success: function (response) {
                callback();
            }
        });
    };

    /*
     This will convert the date to the current timezone and remove the T and Z
     The date param should be a Date() object
     */
    var formatISODate = function (date, showSeconds = true) {
        var d2 = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        var endIndex = showSeconds ? 19 : 16;
        return d2.toISOString().replace("T", " ").substring(0, endIndex);
    };
    
	var decodeText = function(text) {
        if (text !== undefined) {
            return text
                .replace(/\\xE0/g, '\xE0')
                .replace(/\\xE2/g, '\xE2')
                .replace(/\\xE3/g, '\xE3')
                .replace(/\\xE4/g, '\xE4')
                .replace(/\\xE5/g, '\xE5')
                .replace(/\\xE7/g, '\xE7')
                .replace(/\\xE9/g, '\xE9')
                .replace(/\\xE8/g, '\xE8')
                .replace(/\\xEA/g, '\xEA')
                .replace(/\\xEB/g, '\xEB')
                .replace(/\\xED/g, '\xED')
                .replace(/\\xEE/g, '\xEE')
                .replace(/\\xEF/g, '\xEF')
                .replace(/\\xF1/g, '\xF1')
                .replace(/\\xF2/g, '\xF2')
                .replace(/\\xF3/g, '\xF3')
                .replace(/\\xF4/g, '\xF4')
                .replace(/\\xF6/g, '\xF6')
                .replace(/\\xF9/g, '\xF9')
                .replace(/\\xFB/g, '\xFB')
                .replace(/\\xFC/g, '\xFC')
                .replace(/\\xC0/g, '\xC0')
                .replace(/\\xC2/g, '\xC2')
                .replace(/\\xC7/g, '\xC7')
                .replace(/\\xC8/g, '\xC8')
                .replace(/\\xC9/g, '\xC9')
                .replace(/\\xCA/g, '\xCA')
                .replace(/\\xCB/g, '\xCB')
                .replace(/\\xCE/g, '\xCE')
                .replace(/\\xCF/g, '\xCF')
                .replace(/\\xD1/g, '\xD1')
                .replace(/\\xD4/g, '\xD4')
                .replace(/\\xD9/g, '\xD9')
                .replace(/\\xDB/g, '\xDB')
                .replace(/\\xDC/g, '\xDC');
        }
        return text;
    };
    
    var decryptISO = function(text) {
        return eval('"' + text + '"');
    };

    $(window).ready(function () {
        $('.js-close-popup').click(closePopup);
        $('.js-continue-popup-btn').click(resumeEvent);
        $('.toggle-trigger-element:not(input[type=radio])').on('click', toggleElement);
        $('input[type=radio].toggle-trigger-element').on('change', toggleElement);
    });

    Fw.component.export('utils', {
        recaptcha,
        getViewportState,
        isSM,
        isXS,
        isIP,
        addOrReplaceParam,
        getParamsMap,
        fetchPortionOfSite,
        clamp,
        debounce,
        removeLowercaseDiacritics,
        formatNumberToMoney,
        scrollToElement,
        isJson,
        priceTextToFloat,
        appendDataToSubmit,
        getRequestParams,
        requestParamsObjectToString,
        setRequestParams,
        sendEmail,
        slugify,
        saveMG2SessionVariable,
        formatISODate,
        decodeText,
        decryptISO
    });

})(jQuery);
